"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scheduler = exports.ScheduleOption = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _RadioGroup = _interopRequireDefault(require("@civicplus/preamble/lib/RadioGroup/RadioGroup"));

var _Typography = _interopRequireDefault(require("@civicplus/preamble/lib/Typography"));

var _Format = require("../../Utility/Format");

var _DateTimePicker = _interopRequireDefault(require("@civicplus/preamble/lib/DateTimePicker/DateTimePicker"));

var _Validations = _interopRequireWildcard(require("@civicplus/preamble/lib/Validations"));

var _ButtonGroup = _interopRequireDefault(require("@civicplus/preamble/lib/ButtonGroup/ButtonGroup"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _Grid = _interopRequireDefault(require("@civicplus/preamble/lib/Grid"));

var _TextInput = _interopRequireDefault(require("@civicplus/preamble/lib/TextInput/TextInput"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var EnhancedDatePicker = (0, _Validations["default"])(_DateTimePicker["default"]);
var ScheduleOption;
exports.ScheduleOption = ScheduleOption;

(function (ScheduleOption) {
  ScheduleOption[ScheduleOption["Now"] = 0] = "Now";
  ScheduleOption[ScheduleOption["Scheduled"] = 1] = "Scheduled";
})(ScheduleOption || (exports.ScheduleOption = ScheduleOption = {}));

var Scheduler = function Scheduler(props) {
  var _props$item$notificat, _props$item$notificat2, _props$item$scheduleJ, _props$item$scheduleJ2;

  var _useState = (0, _react.useState)((_props$item$notificat = (_props$item$notificat2 = props.item.notificationDetails) === null || _props$item$notificat2 === void 0 ? void 0 : _props$item$notificat2.notificationOption) !== null && _props$item$notificat !== void 0 ? _props$item$notificat : _sdk.NotificationOption.None),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      notification = _useState2[0],
      setNotification = _useState2[1];

  var _useState3 = (0, _react.useState)((_props$item$scheduleJ = props.item.scheduleJob) !== null && _props$item$scheduleJ !== void 0 && _props$item$scheduleJ.dueTime ? ScheduleOption.Scheduled : ScheduleOption.Now),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      schedule = _useState4[0],
      setSchedule = _useState4[1];

  var _useState5 = (0, _react.useState)((_props$item$scheduleJ2 = props.item.scheduleJob) === null || _props$item$scheduleJ2 === void 0 ? void 0 : _props$item$scheduleJ2.dueTime),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      changeDate = _useState6[0],
      setChangeDate = _useState6[1];

  var _useState7 = (0, _react.useState)(props.item),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      item = _useState8[0],
      setItem = _useState8[1];

  var currentDate = (0, _react.useRef)(new Date(Date.now()));
  (0, _react.useEffect)(function () {
    // We need to set notification option defaults if the user didn't type anything, and a default was provided.
    // We are specifically checking undefined, because we do not want to override anything the user has done
    if (item.notificationDetails && item.notificationDetails.notificationOption !== _sdk.NotificationOption.None) {
      if (item.notificationDetails.subject === undefined && props.defaultEmailSubject) {
        item.notificationDetails.subject = props.defaultEmailSubject;
      }

      if (item.notificationDetails.emailIntroduction === undefined && props.defaultEmailIntroduction) {
        item.notificationDetails.emailIntroduction = props.defaultEmailIntroduction;
      }

      if (item.notificationDetails.smsMessage === undefined && props.defaultTextMessage) {
        item.notificationDetails.smsMessage = props.defaultTextMessage;
      }
    } // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [notification, item]);

  var onConfirm = function onConfirm() {
    props.onConfirm(item);
  };

  var updateSchedule = function updateSchedule(option) {
    setSchedule(option);

    if (option === ScheduleOption.Now) {
      setChangeDate(undefined);

      if (item.scheduleJob) {
        item.scheduleJob.dueTime = undefined;
      }
    }
  };

  var canSubmit = function canSubmit() {
    if (schedule === ScheduleOption.Scheduled && !changeDate) {
      return false;
    }

    return true;
  };

  var showExtraDetails = notification !== _sdk.NotificationOption.None;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id,
    className: "prmbl-scheduler"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: showExtraDetails ? 5 : 12
  }, /*#__PURE__*/_react["default"].createElement(ScheduleOptions, {
    value: schedule,
    status: props.status,
    onChange: updateSchedule
  }), /*#__PURE__*/_react["default"].createElement(ChangeStatusDatePicker, {
    schedule: schedule,
    minDate: currentDate.current,
    status: props.status,
    value: changeDate,
    item: props.item,
    onChange: function onChange(item, date) {
      setChangeDate(date);
      setItem(item);
    }
  }), /*#__PURE__*/_react["default"].createElement(NotificationRadioOptions, {
    item: item,
    value: notification,
    status: props.status,
    onChange: function onChange(item) {
      var _item$notificationDet, _item$notificationDet2;

      setNotification((_item$notificationDet = (_item$notificationDet2 = item.notificationDetails) === null || _item$notificationDet2 === void 0 ? void 0 : _item$notificationDet2.notificationOption) !== null && _item$notificationDet !== void 0 ? _item$notificationDet : _sdk.NotificationOption.None);
      setItem(item);
    }
  })), showExtraDetails && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "prmbl-scheduler-notificationDetails",
    item: true,
    xs: 7
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, "Notification Details"), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(DaysInAdvance, {
    item: item,
    notification: notification,
    onChange: setItem
  }), /*#__PURE__*/_react["default"].createElement(EmailSubject, {
    item: item,
    notification: notification,
    onChange: setItem,
    defaultEmailSubject: props.defaultEmailSubject
  }), /*#__PURE__*/_react["default"].createElement(EmailIntroduction, {
    item: item,
    notification: notification,
    onChange: setItem,
    defaultEmailIntroduction: props.defaultEmailIntroduction
  }), /*#__PURE__*/_react["default"].createElement(TextMessage, {
    item: item,
    notification: notification,
    onChange: setItem,
    defaultTextMessage: props.defaultTextMessage
  })))), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
    layout: "right"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: props.onCancel
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onConfirm,
    disabled: !canSubmit()
  }, "Confirm")));
};

exports.Scheduler = Scheduler;

var ScheduleOptions = function ScheduleOptions(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, "Scheduling"), /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    id: "schedule-options",
    className: "prmbl-scheduler-scheduleOptions",
    name: "schedule-options",
    options: [{
      label: "Set to ".concat(props.status, " immediately."),
      value: ScheduleOption.Now,
      id: "nopt1"
    }, {
      label: "Set to ".concat(props.status, " at a later date."),
      value: ScheduleOption.Scheduled,
      id: "nopt2"
    }],
    onChange: function onChange(e) {
      props.onChange(parseInt(e.target.value, 10));
    },
    value: props.value
  }));
};

var ChangeStatusDatePicker = function ChangeStatusDatePicker(props) {
  if (props.schedule !== ScheduleOption.Scheduled) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(EnhancedDatePicker, {
    className: "prmbl-scheduler-changeStatusDate",
    label: "Publish Date",
    format: "MM/dd/yyyy h:mm a",
    onChange: function onChange(e) {
      var value = new Date(e.target.value);

      var item = _objectSpread({}, props.item);

      item.scheduleJob = {
        status: props.status,
        dueTime: value,
        scheduledBy: ""
      };
      props.onChange(item, value);
    },
    value: props.value,
    validations: [_Validations.validDateValidation, _Validations.minValueDateValidation, _Validations.maxValueDateValidation],
    keyboard: true,
    minValue: props.minDate,
    pickerType: "dateTime"
  });
};

var NotificationRadioOptions = function NotificationRadioOptions(props) {
  var NotificationOptions = function NotificationOptions(status, schema) {
    if (status !== "Published") {
      return [];
    }

    var options = [];
    options.push({
      id: "op1",
      value: _sdk.NotificationOption.None,
      label: "Do not send notification"
    });
    options.push({
      id: "op2",
      value: _sdk.NotificationOption.OnPublishDate,
      color: "default",
      label: "Send notification on publish date"
    });

    if (schema) {
      var _date = schema.fields.find(function (w) {
        return w.properties.fieldType === "DateTime" || w.properties.fieldType === "DateTimeRange";
      });

      if (_date) {
        options.push({
          id: "op3",
          value: _sdk.NotificationOption.DaysInAdvance,
          color: "default",
          label: "Send based on ".concat((0, _Format.displayable)(_date), " field")
        });
      }
    }

    return options;
  };

  var options = NotificationOptions(props.status, props.schema);

  if (options.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: "1em"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, "Notify Your Users"), /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    id: "notification-options",
    className: "prmbl-scheduler-notificationOptions",
    name: "notifications-options",
    options: options,
    onChange: function onChange(e) {
      var _item$notificationDet3;

      var option = e.target.value;

      var item = _objectSpread({}, props.item);

      item.notificationDetails = (_item$notificationDet3 = item.notificationDetails) !== null && _item$notificationDet3 !== void 0 ? _item$notificationDet3 : {};
      item.notificationDetails.notificationOption = option;
      props.onChange(item);
    },
    value: props.value
  }));
};

var DaysInAdvance = function DaysInAdvance(props) {
  var _item$notificationDet4, _item$notificationDet5;

  if (props.notification !== _sdk.NotificationOption.DaysInAdvance) {
    return null;
  }

  var item = props.item;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    className: "prmbl-scheduler-daysInAdvance",
    type: "number",
    value: (_item$notificationDet4 = (_item$notificationDet5 = item.notificationDetails) === null || _item$notificationDet5 === void 0 ? void 0 : _item$notificationDet5.daysInAdvance) !== null && _item$notificationDet4 !== void 0 ? _item$notificationDet4 : 0,
    label: "Days in Advance",
    onChange: function onChange(e) {
      var _item$notificationDet6;

      item.notificationDetails = (_item$notificationDet6 = item.notificationDetails) !== null && _item$notificationDet6 !== void 0 ? _item$notificationDet6 : {};
      item.notificationDetails.daysInAdvance = parseInt(e.target.value, 10);
      props.onChange(_objectSpread({}, item));
    }
  }));
};

var EmailSubject = function EmailSubject(props) {
  var _item$notificationDet7;

  if (props.notification === _sdk.NotificationOption.None) {
    return null;
  }

  var item = props.item;
  var value = (_item$notificationDet7 = item.notificationDetails) === null || _item$notificationDet7 === void 0 ? void 0 : _item$notificationDet7.subject;

  if (value === undefined) {
    value = props.defaultEmailSubject;
  }

  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    className: "prmbl-scheduler-emailSubject",
    type: "text",
    value: value,
    label: "Email Subject",
    onChange: function onChange(e) {
      var _item$notificationDet8;

      item.notificationDetails = (_item$notificationDet8 = item.notificationDetails) !== null && _item$notificationDet8 !== void 0 ? _item$notificationDet8 : {};
      item.notificationDetails.subject = e.target.value;
      props.onChange(_objectSpread({}, item));
    },
    fullWidth: true
  }));
};

var EmailIntroduction = function EmailIntroduction(props) {
  var _item$notificationDet9;

  if (props.notification === _sdk.NotificationOption.None) {
    return null;
  }

  var item = props.item;
  var value = (_item$notificationDet9 = item.notificationDetails) === null || _item$notificationDet9 === void 0 ? void 0 : _item$notificationDet9.emailIntroduction;

  if (value === undefined) {
    value = props.defaultEmailIntroduction;
  }

  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    className: "prmbl-scheduler-emailIntroduction",
    type: "text",
    value: value,
    label: "Email Introduction",
    onChange: function onChange(e) {
      var _item$notificationDet10;

      item.notificationDetails = (_item$notificationDet10 = item.notificationDetails) !== null && _item$notificationDet10 !== void 0 ? _item$notificationDet10 : {};
      item.notificationDetails.emailIntroduction = e.target.value;
      props.onChange(_objectSpread({}, item));
    },
    fullWidth: true
  }));
};

var TextMessage = function TextMessage(props) {
  var _item$notificationDet11;

  if (props.notification === _sdk.NotificationOption.None) {
    return null;
  }

  var item = props.item;
  var value = (_item$notificationDet11 = item.notificationDetails) === null || _item$notificationDet11 === void 0 ? void 0 : _item$notificationDet11.smsMessage;

  if (value === undefined) {
    value = props.defaultTextMessage;
  }

  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    className: "prmbl-scheduler-textMessage",
    type: "text",
    value: value,
    label: "Text Message (SMS)",
    onChange: function onChange(e) {
      var _item$notificationDet12;

      item.notificationDetails = (_item$notificationDet12 = item.notificationDetails) !== null && _item$notificationDet12 !== void 0 ? _item$notificationDet12 : {};
      item.notificationDetails.smsMessage = e.target.value;
      props.onChange(_objectSpread({}, item));
    },
    fullWidth: true
  }));
};